import {  FromEventPatternObservable  } from './FromEventPatternObservable';

export const fromEventPattern = FromEventPatternObservable.create;


// WEBPACK FOOTER //
// ../../src/observable/fromEventPattern.ts